export const MODAL_CLOSING_DURATION = 500;

export const ACHAccountType: Record<string, string> = {
  personal_checking: 'Personal Checking',
  personal_savings: 'Personal Savings',
  business_checking: 'Business Checking',
  business_savings: 'Business Savings',
};
